<script setup lang="ts">
import { onMounted, ref } from 'vue'
import type {
  CommercialActivityStatsViewModel,
} from '@/lib/types'
import { generateField } from '@/lib/utils'
import ActiviteCommercialRepository from '@/repository/ActiviteCommercialRepository'
import CardInfoContent from '@/components/ui/card/CardInfoContent.vue'
import { usePercentageMode } from '@/lib/usePercentageMode'
import Card from '@/components/ui/card/Card.vue'

const fields = ref<{ label: string; value: number; percentage?: number; color?: string }[]>([])
const data = ref<CommercialActivityStatsViewModel | null>()
const { isPercentageMode } = usePercentageMode(false)

const updateInfoCardFields = () => {
  if (data.value) {
    fields.value = [
      generateField(false, data.value, 'Nombre total de visites', 'total_visites'),
      generateField(
        false,
        data.value,
        'Moyenne visites/jours',
        'moyenne_visites_jours',
        null,
        'Moyenne visites/jours',
      ),
      generateField(false, data.value, 'Nombre de commerciaux', 'nombre_de_commerciaux'),
      generateField(
        false,
        data.value,
        'Nombre de visites clients',
        'visites_clients',
      ),
      generateField(
        false,
        data.value,
        'Nombre de relance commercial',
        'relances_commerciales',
      ),
    ]
  }
}

onMounted(async () => {
  data.value = await ActiviteCommercialRepository.getInfoCardData()
  updateInfoCardFields()
})
</script>

<template>
  <Card
    title="Activité commercial (mois)"
    v-model:percentage-mode="isPercentageMode"
    :percent-icon="true"
  >
    <CardInfoContent :fields="fields || []" :skeletons="5" :percentage-mode="isPercentageMode" />
  </Card>
</template>
